import React, { useRef, useEffect } from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import FormLightboxButton, {
	IFormLightboxButtonProps,
} from '../FormLightboxButton';
import Button from 'tbk-components/src/components/Button';

export interface IFloatingCTA extends IBaseElementProps {
	productName?: string;
	formLightboxButtons?: IFormLightboxButtonProps[];
	inHero?: boolean;
}

/**
 * Calian Floating CTA
 * This block is found floating under the editor, making it difficult to see.
 * Please enter the values, and save the page to see the block on the front end.
 * @icon welcome-widgets-menus
 * @block
 */
const FloatingCTA: React.FC<IFloatingCTA> = ({
	id,
	className,
	classNames = [],
	productName,
	formLightboxButtons = [],
	inHero = false,
}) => {
	const ref = useRef(null);

	useEffect(() => {
		const bottomReached = () => {
			if (
				document.body.offsetHeight <=
				document.documentElement.scrollTop + window.innerHeight
			) {
				ref.current.style.bottom = `${-1 * ref.current.offsetHeight}px`;
			} else {
				ref.current.style.bottom = '';
			}
		};
		window.addEventListener('scroll', bottomReached);
		window.addEventListener('load', bottomReached);

		return () => {
			window.removeEventListener('scroll', bottomReached);
			window.removeEventListener('load', bottomReached);
		};
	}, []);

	return (
		<div
			id={id}
			className={
				className ||
				cn(
					'floating-cta__container',
					inHero && 'in-hero-banner',
					...classNames,
				)
			}
			ref={ref}
		>
			<div className="floating-cta__container-inner">
				{productName && !inHero && <p>{productName}</p>}
				{formLightboxButtons.length > 0 && (
					<div className="floating-cta__buttons d-flex flex-sm-row flex-column">
						{formLightboxButtons.map((item, index) =>
							item.form?.hubSpotEmbedCode ? (
								<FormLightboxButton key={index} {...item} />
							) : (
								<Button
									key={index}
									className={cn('btn', {
										[`btn-${item?.buttonColor?.toLowerCase()}`]:
											item?.buttonColor,
										[`btn-${item?.buttonSize?.toLowerCase()}`]:
											item?.buttonSize,
									})}
									{...item?.formLightboxButton}
								/>
							),
						)}
					</div>
				)}
			</div>
		</div>
	);
};

export default FloatingCTA;
